import { getConfig } from '../config';
import { deleteCookie, getCookie, setCookie } from '../utils/cookies';
import { clearTimers } from './timers';
/**
 * Last retrieved session
 */
let _cachedSession;
/**
 * Retrieve the session object from the cache immediately.
 */
export function getCachedSession() {
    const token = getCurrentSessionToken();
    if (!token) {
        _cachedSession = undefined;
        return;
    }
    return _cachedSession;
}
/**
 * Clear the cached session and remove any cookies, timers or other cached values
 * that depend on a valid session.
 */
export function clearCurrentSession() {
    _cachedSession = undefined;
    const cookieId = getConfig().AUTH_COOKIE_IDENTIFIER;
    if (cookieId) {
        deleteCookie(cookieId, true);
    }
    const cookieIdAdmin = getConfig().AUTH_FROM_ADMIN_KEY;
    if (cookieIdAdmin) {
        deleteCookie(cookieIdAdmin);
    }
    clearTimers();
}
export function setCurrentSessionToken(token) {
    const cookieId = getConfig().AUTH_COOKIE_IDENTIFIER;
    if (cookieId) {
        setCookie(cookieId, token, {}, true);
    }
}
/**
 * Save a created or refreshed session into the local cache and cookies.
 */
export function setCurrentSession(session) {
    setCurrentSessionToken(session.authentication.dashboard);
    _cachedSession = session;
}
export function getCurrentSessionToken() {
    if (_cachedSession) {
        return _cachedSession.authentication.dashboard;
    }
    const cookieId = getConfig().AUTH_COOKIE_IDENTIFIER;
    return cookieId ? getCookie(cookieId) : undefined;
}
